import React, { useEffect, useState } from "react";
import api from 'api';
import { useLocation } from 'react-router-dom';
import { API } from "common/config-api"; // jsconfig.json

const UserTabPurchaseRow = ({p}) => {
  console.log("p", p);
  return (
  <tr>
    <td>{p.productName}</td>
    <td>{p.salesProductQuantity}</td>
    <td>￥{p.salesProductPrice.toLocaleString('ko-KR')}</td>
    <td>￥{(p.salesProductQuantity * p.salesProductPrice).toLocaleString('ko-KR')}</td>
    <td><code>{p.salesProductDate}</code></td>
  </tr>
  );
}

const UserTabPurchase = ({idx}) => {

  const location = useLocation();
  console.log("location", location);
  const apiUrl = `${API.BASE_URL}`;

  const [userPurchaseList, setUserPurchaseList] = useState([]);
  const [userPurchaseTotal, setUserPurchaseTotal] = useState(0);


  const getUserPurchase = async () => {
    try {
      const response = await api.get(apiUrl + '/sales/user/' + idx);
      const resp = response;
      console.log("resp", resp);
      setUserPurchaseList(resp);
    } catch (error) {
      console.error('사용자 구매 목록 조회 실패:', error);
      alert('사용자 구매 목록 조회 중 오류가 발생했습니다.');
    }
  };

  const getUserTotalPurchase = async () => {
    try {
      const response = await api.get(apiUrl + '/sales/user/total/' + idx);
      const resp = response;
      console.log("resp", resp);
      setUserPurchaseTotal(resp);
    } catch (error) {
      console.error('사용자 총 구매액 조회 실패:', error);
      alert('사용자 총 구매액 조회 중 오류가 발생했습니다.');
    }
  };

  useEffect(() => {
    getUserPurchase();
    getUserTotalPurchase();
  }, []);

  return(

    <table className="table table-hover">
      <thead>
        <tr>
          <th colSpan="5">총 구매금액: ￥{userPurchaseTotal.toLocaleString('ko-KR')}</th>
        </tr>                    
        <tr>
          <th scope="col">상품명</th>
          <th scope="col">수량</th>
          <th scope="col">단가</th>
          <th scope="col">금액</th>
          <th scope="col">날짜</th>
        </tr>
      </thead>
      <tbody>
        {userPurchaseList.length === 0 ? <tr><td colSpan="4">입력된 내용이 없습니다.</td></tr> : userPurchaseList.map((data, idx) => ( <UserTabPurchaseRow key={idx} p={data} /> ))}
      </tbody>
    </table>

  );
}

export default UserTabPurchase;




